import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, InputNumber, Switch } from "antd";

export const CurrencyCreate: React.FC = () => {
    const [form] = Form.useForm();
    const { formProps, saveButtonProps } = useForm({
        resource: "currency",
        meta: {
            fields: [
                "currencyCode",
                "name",
                "symbol",
                "exchangeRate",
                "isBaseCurrency",
                "isActive"
            ],
        }
    });

    return (
        <Create
            saveButtonProps={saveButtonProps}
        >
            <Form form={form} {...formProps} layout="vertical">
                <Form.Item
                    label="Currency Code"
                    name="currencyCode"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. USD" maxLength={10} />
                </Form.Item>

                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. United States Dollar" />
                </Form.Item>

                <Form.Item
                    label="Symbol"
                    name="symbol"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. $" maxLength={5} />
                </Form.Item>

                <Form.Item
                    label="Exchange Rate"
                    name="exchangeRate"
                    rules={[{ required: true, type: 'number', min: 0.000001 }]}
                    initialValue={1.0}
                >
                    <InputNumber
                        placeholder="e.g. 1.0"
                        step={0.0001}
                        precision={4}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    label="Is Base Currency"
                    name="isBaseCurrency"
                    valuePropName="checked"
                    initialValue={false}
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    label="Is Active"
                    name="isActive"
                    valuePropName="checked"
                    initialValue={true}
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Create>
    );
}; 